export const sendEmailToCustomerQueryBusinessCar = `mutation triggerEvent($comparisonId: String!, $email: String!, $productType: ProductType!) {
    triggerEvent(input: { continueComparing: { 
    comparisonId: $comparisonId 
    email: $email, 
    productType: $productType
  } }) { 
      success 
    } 
}`;

export const sendInactivityEmailToCustomerQueryBusinessCar = `mutation triggerEvent($comparisonId: String!, $email: String!, $productType: ProductType!) {
    triggerEvent(input: { continueComparingInactivity: { 
    comparisonId: $comparisonId 
    email: $email, 
    productType: $productType
  } }) { 
      success 
    } 
}`;
